// STATE
const state = () => ({
    communications: null,
});

export default state;